/**
 * Replace multiple substrings according to a map object.
 *
 * The map should consist of key value pairs where the key equals the substring
 * to be replaced, and the value equals the replacement string.
 *
 * @link https://stackoverflow.com/a/15604206/1801260
 *
 * @param {string} subject
 * @param {object} map
 * @returns string
 */
export default function (subject, map) {
  const pattern = new RegExp(Object.keys(map).join('|'), 'gi');
  return subject.replace(pattern, (matched) => map[matched]);
}
